import GruposAdmin from "../../../components/GruposAdmin";

export function GruposGeral() {
    return (
        <GruposAdmin
            tipo="ofertas"
            titulo="Controle de Acessos - Grupo Geral"
        />
    );
}

export function GruposCelular() {
    return (
        <GruposAdmin
            tipo="celular"
            titulo="Controle de Acessos - Grupo Celular"
        />
    );
}

export function GruposXiaomi() {
    return (
        <GruposAdmin
            tipo="xiaomi"
            titulo="Controle de Acessos - Grupo Xiaomi"
        />
    );
}

export function GruposSamsung() {
    return (
        <GruposAdmin
            tipo="samsung"
            titulo="Controle de Acessos - Grupo Samsung"
        />
    );
}

export function GruposMotorola() {
    return (
        <GruposAdmin
            tipo="motorola"
            titulo="Controle de Acessos - Grupo Motorola"
        />
    );
}

export function GruposApple() {
    return (
        <GruposAdmin
            tipo="apple"
            titulo="Controle de Acessos - Grupo Apple"
        />
    );
}

export function GruposHiperfoco() {
    return (
        <GruposAdmin
            tipo="hiperfoco"
            titulo="Controle de Acessos - Grupo Hiperfoco"
        />
    );
}

export function GruposTrafego() {
    return (
        <GruposAdmin
            tipo="trafego"
            titulo="Controle de Acessos - Grupo Tráfego"
        />
    );
}
